<template>

	<table class="table table-sm table-bordered table-striped" style="text-align: center">
		<thead>								
			<tr>
				<td>Productos</td>
				<td>Recetas</td>
				<td>Anulados</td>
				<td>Total Pedidos</td>
				<td>Total Recetas</td>
				<td>Total Anulados</td>
				<td>Diferencia</td>
			</tr>
		</thead>
		<tbody>
			<tr v-if="data">
				<td>{{ cantidadArticulos }}</td>
				<td>{{ cantidadRecetas   }}</td>
				<td>{{ cantidadAnulados  }}</td>
				<td>{{ totalPedidos | currency('$', 2, { thousandsSeparator: '.' , decimalSeparator: ',' }) }}</td>
				<td>{{ totalRecetas | currency('$', 2, { thousandsSeparator: '.' , decimalSeparator: ',' }) }}</td>
				<td>{{ totalAnulados| currency('$', 2, { thousandsSeparator: '.' , decimalSeparator: ',' }) }}</td>
				<td :style="[ diferencia  ? {'background':'#F44336 !important', 'color':'white'} : {'background':'#8BC34A !important;'} ]">
					{{ diferencia | currency('$', 2, { thousandsSeparator: '.' , decimalSeparator: ',' })}}
				</td>
			</tr>
			<tr v-else>
				<td colspan="7" style="text-align: center;">
					No se encontró información de facturación.
				</td>
			</tr>
		</tbody>
	</table>	

</template>

<script>

    export default {
        props: {
			data: {
				type	: Object,
				required: true,
			}
          },
        name:"facturacion",
		data() {
			return {
				cantidadArticulos : 0,
                cantidadRecetas   : 0,
                receta            : null,
                cantidadAnulados  : 0,
                totalPedidos      : 0,
                detalle           : null,
                totalRecetas      : 0,
                totalAnulados     : 0,
                diferencia        : null,
			}
		},
		created() {
			this.procesarData()
		},
		watch: {
			receta() {
                if (this.receta) {
                    this.cantidadAnulados = this.buscarAnulados({ recetas: this.receta  })
                    this.totalPedidos     = this.sumarPedidos({   pedidos: this.detalle })                    
                    this.totalRecetas     = this.sumarRecetas({   recetas: this.receta  })                    
                    this.totalAnulados    = this.sumarAnulados({  recetas: this.receta  })
                    this.diferencia       = this.totalPedidos - this.totalRecetas                    
                }
            },
		},
		methods:{
			procesarData() {
				const {seguimiento, cambios_estado, guia, detalle, receta} = this.data
             console.log('receta', receta);           
                this.cambiosEstados    = cambios_estado ? cambios_estado : []
                this.cantidadArticulos = detalle        ? detalle.length : 0
                this.cantidadRecetas   = receta         ? receta.length  : 0
                this.detalle           = detalle        ? detalle        : []
                this.guia              = guia           ? guia           : []
                this.receta            = receta         ? receta         : []
                this.seguimiento       = seguimiento    ? seguimiento[0] : []

                console.log('componente facturación SEGUIMIENTO', this.seguimiento);
                console.log('componente facturación CAMBIO DE ESTADOS', this.cambiosEstados);
			},
		
			buscarAnulados({recetas}) {                
                if (recetas && recetas.length) return recetas.filter( (a) => a.estado === 'A').length
                return 0
			},

            sumarPedidos({pedidos}) {
                if (pedidos && pedidos.length) return pedidos.map( (a) => a.total).reduce( (b, c) => parseFloat(b) + parseFloat(c), 0)
                return 0 
			},

            sumarRecetas({recetas}) {
                if (recetas && recetas.length) return recetas.filter( (r) => { if(r && r.estado) return r.estado === 'F' })
                                                                .map( (b) => (!b.cantfin ? b.importe * b.cantidad1 : b.importe * b.cantfin) )
                                                                .reduce( (c, d) => parseFloat(c) + parseFloat(d), 0)
                return 0
			},

            sumarAnulados({recetas}) {
                if (recetas && recetas.length) return recetas.filter( (r) => { if(r && r.estado) return r.estado === 'A'})
                                                                .map( (b) => b.importe * (b.cantidad1 ? b.cantidad1 : 1) )
                                                                .reduce( (c,d) => parseFloat(c) + parseFloat(d), 0)
				return 0
			},  
		},       
       
    }
</script>

<style scoped>
	td {
		font-weight: 500 !important;
	}
</style>
